import * as React from "react";
import {createRoot} from "react-dom/client";
import {Cart} from "./components/cart/Cart/Cart";
import {Provider} from "react-redux";
import {store} from "./store";

export const init = (): void => {
  // This is the react root of our cart / application
  const cartElement = document.createElement("div") as HTMLElement;
  document.body.appendChild(cartElement);

  // region portals to everywhere

  // Element to render modal content in - outside of the dom to prevent css side effects
  const modalRootElement = document.createElement("div");
  modalRootElement.id = "ModalRootElement";
  document.body.appendChild(modalRootElement);

  const reactCartIcon: HTMLAnchorElement | null = document.querySelector("#CartIcon");
  if (reactCartIcon) {
    const cartIcon = document.createElement("span");
    cartIcon.id = "CartIconRoot";
    document.body.appendChild(cartIcon);
  }

  const addToCartButtonRoot = document.createElement("div");
  addToCartButtonRoot.id = "AddToCartButtonRoot";
  addToCartButtonRoot.className = "product-cart__form";
  document.body.appendChild(addToCartButtonRoot);

  const addToWishlistOrig = document.getElementsByClassName("product-cart__wishlist")[0];
  if (addToWishlistOrig) {
    const addToWishlistNew = document.createElement("div");
    addToWishlistNew.id = "AddToWishlistButtonNew";
    addToWishlistNew.className = addToWishlistOrig.className;
    document.body.appendChild(addToWishlistNew);
  }

  // endregion

  const root = createRoot(cartElement);
  root.render(
    <Provider store={store}>
      <Cart />
    </Provider>,
  );
};
